import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import prospectWebhooksAPI from '../../api/prospectWebhooks';

const state = {
  records: [],
  uiFlags: {
    fetchingList: false,
    creatingItem: false,
    deletingItem: false,
    updatingItem: false,
  },
};

export const getters = {
  getProspectWebhooks(_state) {
    return _state.records.sort((a, b) => a.id - b.id);
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  async get({ commit }) {
    commit(types.default.SET_PROSPECT_WEBHOOK_UI_FLAG, { fetchingList: true });
    try {
      const response = await prospectWebhooksAPI.get();
      commit(types.default.SET_PROSPECT_WEBHOOKS, response.data);
    } catch (error) {
      // ignore
    } finally {
      commit(types.default.SET_PROSPECT_WEBHOOK_UI_FLAG, {
        fetchingList: false,
      });
    }
  },

  async create({ commit }, params) {
    commit(types.default.SET_PROSPECT_WEBHOOK_UI_FLAG, { creatingItem: true });
    try {
      const response = await prospectWebhooksAPI.create(params);
      commit(types.default.ADD_PROSPECT_WEBHOOK, response.data);
    } finally {
      commit(types.default.SET_PROSPECT_WEBHOOK_UI_FLAG, {
        creatingItem: false,
      });
    }
  },

  async update({ commit }, { id, ...updateObj }) {
    commit(types.default.SET_PROSPECT_WEBHOOK_UI_FLAG, { updatingItem: true });
    try {
      const response = await prospectWebhooksAPI.update(id, updateObj);
      commit(types.default.UPDATE_PROSPECT_WEBHOOK, response.data);
    } finally {
      commit(types.default.SET_PROSPECT_WEBHOOK_UI_FLAG, {
        updatingItem: false,
      });
    }
  },

  async delete({ commit }, id) {
    commit(types.default.SET_PROSPECT_WEBHOOK_UI_FLAG, { deletingItem: true });
    try {
      await prospectWebhooksAPI.delete(id);
      commit(types.default.DELETE_PROSPECT_WEBHOOK, id);
    } finally {
      commit(types.default.SET_PROSPECT_WEBHOOK_UI_FLAG, {
        deletingItem: false,
      });
    }
  },
};

export const mutations = {
  [types.default.SET_PROSPECT_WEBHOOK_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.default.SET_PROSPECT_WEBHOOKS]: MutationHelpers.set,
  [types.default.ADD_PROSPECT_WEBHOOK]: MutationHelpers.create,
  [types.default.DELETE_PROSPECT_WEBHOOK]: MutationHelpers.destroy,
  [types.default.UPDATE_PROSPECT_WEBHOOK]: MutationHelpers.update,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
